import { render, staticRenderFns } from "./shop_more.vue?vue&type=template&id=34e11212&scoped=true"
import script from "./shop_more.vue?vue&type=script&lang=js"
export * from "./shop_more.vue?vue&type=script&lang=js"
import style0 from "./shop_more.vue?vue&type=style&index=0&id=34e11212&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e11212",
  null
  
)

export default component.exports